import Icon from '../components/Icon.vue'

Icon.register({"html5":{"width":1408,"height":1792,"paths":[{"d":"M1130 597l16-175h-884l47 534h612l-22 228-197 53-196-53-13-140h-175l22 278 362 100h4v-1l359-99 50-544h-644l-15-181h674zM0 128h1408l-128 1438-578 162-574-162z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/html5.js